import React, {useState } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import moment from 'moment';

import Loading from "../components/Loading";
import Navigation from "../components/Navigation";
import BrandBar from "../components/BrandBar";

// Charts
import NewsletterStats from "../components/widgets/marketing/NewsletterStats";
import TimelineNewsletter from "../components/widgets/marketing/TimelineNewsletter";
import NewsletterCampaigns from "../components/widgets/marketing/NewsletterCampaigns";
import NewsletterTargets from "../components/widgets/marketing/NewsletterTargets";



export const Newsletter = (props) => {

	//STATE
	const [filterData, setFilterData] = useState({
		active_start_date: new Date('2021-06-21'),
		active_end_date: new Date('2021-06-28'),	
	});

	return (
		<div className="app-container">
			<div className="app-sidebar">
				<BrandBar/>
				<Navigation page_title="Dashboard"/>
			</div>
			
			<div className="app-content">
				<div className="page-content">

					<div className="page-content-inner">
						<div className="page-content-inner-centering--wide">

							<div className="page-content-header">
								
								<div className="page-content-header-titel-block">
									<h1 className="page-title">Nyhedsbrev — Uge 31</h1>

									<div className="page-description">
										<p>
											Denne side bliver ikke opdateret automatisk! Sidst opdatert: 16 Juli 2021
										</p>
									</div>
								</div>

							</div>
						
							<div className="page-charts">
								
								<div className="page-chart-with-sidebar-element">
									
									<div className="page-chart-with-sidebar-element-sidebar">
										<NewsletterStats/>
										<NewsletterTargets/>
									</div>

									<div className="page-chart-with-sidebar-element-main">
										<TimelineNewsletter/>
									</div>

								</div>
								
								<NewsletterCampaigns/>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	); 
};

export default withAuthenticationRequired(Newsletter, {
  onRedirecting: () => <Loading />,
});
